import type { ReactNode } from 'react'
import { Redirect } from 'wouter'
import RequireAuth from './RequireAuth'
import { useAuth } from './useAuth'

interface Props {
  children: ReactNode
}

export default function RequireAdmin({ children }: Props) {
  const { user } = useAuth()

  return (
    <RequireAuth>
      {user?.isAdmin ? <>{children}</> : <Redirect to="/" />}
    </RequireAuth>
  )
}
